.textField {
  /* This variable lets us use a box-shadow to increase border size without shifting content */
  --active-border-size-diff: calc(var(--active-border-size) - var(--default-border-size));
  --clear-button-size: 24px;

  color: var(--content-primary);
  display: block;
  width: 100%;
}

.label {
  display: block;
}

.label.small {
  font: var(--label-md-font);
  margin-bottom: var(--spacing-xs);
}

.label.medium {
  font: var(--label-md-font);
  margin-bottom: var(--spacing-xs);
}

.label.large {
  font: var(--label-lg-font);
  margin-bottom: var(--spacing-sm);
}

.inputBox {
  /* medium */
  --vertical-padding: var(--spacing-md);
  --horizontal-padding: var(--spacing-md);
  --default-border-size: var(--border-width-input-default);
  --active-border-size: var(--border-width-input-focus);

  background: var(--surface-action-input-default);
  height: var(--size-input-height-md);
  border-radius: var(--radius-xl);
  border: var(--border-width-input-default) solid var(--border-action-input-default);
  color: var(--content-input-default);
  cursor: text;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-md);
  font: var(--body-md-font);
  padding: var(--vertical-padding) var(--horizontal-padding);
  box-sizing: border-box;
  position: relative;
  transition:
    border-color 0.1s ease-out,
    box-shadow 0.1s ease-out;

  @media (width <= 768px) {
    font-size: var(--body-md-font-size);
  }
}

.small .inputBox {
  --vertical-padding: var(--spacing-md);
  --horizontal-padding: var(--spacing-md);

  height: var(--size-input-height-sm);
  border-radius: var(--radius-lg);
}

.large .inputBox {
  --vertical-padding: var(--spacing-lg);
  --horizontal-padding: var(--spacing-lg);

  height: var(--size-input-height-lg);
  border-radius: var(--radius-2xl);
  font: var(--body-lg-font);
}

.error > .inputBox {
  border-color: var(--border-action-input-error);
}

.hint {
  color: var(--content-secondary);
  display: block;
  font: var(--body-md-font);
  letter-spacing: var(--body-md-letter-spacing);
  padding-left: var(--spacing-sm);
  margin-top: var(--spacing-xs);
}

.large .hint {
  margin-top: var(--spacing-sm);
}

.error > .hint {
  color: var(--content-status-error);
}

.inputBox:has(input:focus) {
  border-color: var(--border-action-input-focus);
  box-shadow: 0 0 0 var(--active-border-size-diff) var(--border-action-input-focus);
}

.inputBox:has(.input:disabled) {
  background-color: var(--surface-action-input-disabled);
  border-color: var(--border-action-input-disabled);
  color: var(--content-input-disabled);
}

.textField:has(.input:disabled) .label {
  color: var(--content-secondary);
}

.leftSlot {
  display: flex;
  align-items: center;
}

.rightSlot {
  position: absolute;
  margin-right: var(--spacing-xl);
  right: 0;
}

.input {
  appearance: none;
  background: none;
  border: none;
  flex: 1;
  min-width: 0;
  margin: 0;
  min-height: var(--clear-button-size);
  outline: none;
  padding: 0;
  color: inherit;
}

.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button,
.input::-webkit-calendar-picker-indicator {
  appearance: none;
  display: none;
}

.input::placeholder {
  color: var(--content-input-placeholder);
}

.clearButton {
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  height: var(--clear-button-size);
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  visibility: hidden;
  margin-right: var(--spacing-xl);
  width: var(--clear-button-size);
  color: var(--content-secondary);
}

/* disabling this rule here, since there are all applying the same style
 * (so specificity does not matter, AND:) it's easier to describe what's happening in this order */

/* stylelint-disable no-descending-specificity */

/* initially, only show the button when there is text in a focused or hovered input
 * note: :not(placeholder-shown) works because the component inserts an empty space when the placeholder is blank */
.input:not(:placeholder-shown):hover ~ .clearButton,
.input:not(:placeholder-shown):focus ~ .clearButton,
/* but we also need to keep the button visible if you are interacting with it */
.clearButton:hover,
.clearButton:focus,
.clearButton:active {
  visibility: visible;
}

/* hide the right slot when the clear button should be visible */
.input:not(:placeholder-shown):hover ~ .rightSlot,
.input:not(:placeholder-shown):focus ~ .rightSlot {
  visibility: hidden;
}

/* also hide the right slot when interacting with the clear button - this needs to work even after input is cleared */
.inputBox:has(.clearButton:hover) .rightSlot,
.inputBox:has(.clearButton:focus) .rightSlot,
.inputBox:has(.clearButton:active) .rightSlot {
  visibility: hidden;
}

/* stylelint-enable no-descending-specificity */

.textField:hover .inputBox:has(.input:not(:disabled)) {
  box-shadow: 0 0 0 var(--active-border-size-diff) var(--border-action-input-hover);
}

.textField.error:hover .inputBox:has(.input:not(:disabled)) {
  box-shadow: 0 0 0 var(--active-border-size-diff) var(--border-action-input-error);
}

/* declaring sizes here to they all show up in the declaration */

/* stylelint-disable block-no-empty */

.small {
}

.medium {
}

.large {
}

/* stylelint-enable block-no-empty */
